<template>
  <div
    :class="cardClasses"
    data-pendo-ds="card_wrapper"
    :style="cardStyles"
    :tabindex="focusable ? 0 : -1"
    @blur="handleBlur"
    @click="handleClick"
    @focus="handleFocus"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
    @mouseleave="handleMouseLeave"
    @mouseover="handleMouseOver"
  >
    <slot name="content">
      Content goes here
    </slot>
  </div>
</template>

<script>

  const BORDER_RADIUS = ['small', 'medium']
  const PADDING = ['none', 'small', 'medium', 'large']

  export default {
    name: "CardWrapper",
    props: {
      padding: {
        type: String,
        default: "small",
        validator: (value) => PADDING.includes(value),
      },
      borderRadius: {
        type: String,
        default: "small",
        validator: (value) => BORDER_RADIUS.includes(value),
      },
      selectable: {
        type: Boolean,
        default: false,
      },
      actionable: {
        type: Boolean,
        default: false,
      },
      backgroundColor: {
        type: String,
        default: "#FFFFFF",
      },
      borderColor: {
        type: String,
        default: "#E8E8E8",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: 'auto',
      },
    },
    emits: ['update:selected'],
    computed: {
      cardClasses() {
        return [
          'card-wrapper',
          this.paddingClass,
          this.borderRadiusClass,
          {
            selectable: this.selectable && !this.disabled,
            selected: this.isSelected,
            actionable: this.actionable,
            disabled: this.disabled,
          },
        ]
      },
      cardStyles() {
        return {
          backgroundColor: this.disabled ? '' : this.backgroundColor,
          borderColor: this.isSelected || this.disabled ? '' : this.borderColor,
          width: this.width,
        }
      },
      paddingClass() {
        return `padding-${this.padding}`
      },
      borderRadiusClass() {
        return `cr-br-${this.borderRadius}`
      },
      focusable() {
        return (this.selectable || this.actionable) && !this.disabled
      },
    },
    methods: {
      handleClick() {
        if (this.selectable && !this.disabled) {
          this.$emit("update:selected", this.isSelected)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.card-wrapper {
  border: 1px solid var(--pepper-200);
  display: inline-block;
  white-space: break-spaces;

  &:focus-visible {
    outline: 2px solid var(--blueberry-300);
  }
}

.padding-small {
  padding: var(--space-1);
}
.padding-medium {
  padding: var(--space-2) var(--space-3);
}
.padding-large {
  padding: var(--space-4);
}

.selectable:not(.disabled), .actionable:not(.disabled) {
  cursor: pointer;

  &:hover {
    box-shadow: var(--cr-ds-medium);
  }
}

.selected {
  border: 1px solid var(--blueberry-800);
  box-shadow: var(--cr-ds-medium);
}

.disabled {
  cursor: not-allowed;
  background: var(--pepper-50);
  border: 1px solid var(--pepper-400);
  color: var(--pepper-600);
  filter: grayscale(0.80);
}
</style>
